import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { InputSwitch } from "primereact/inputswitch";
import TooltipList from "./Components/TooltipList";
import { Tooltip } from "primereact/tooltip";

const bodyParts = [
    {
        name: "neck",
    },
    {
        name: "back"
    },
    {
        name: "spine",
    },
    {
        name: "shoulder",
    },
    {
        name: "elbow",
    },
    {
        name: "hip",
    },
    {
        name: "knee",
    },
    {
        name: "core",
    },
    {
        name: "abdomen"
    },
    {
        name: "hand"
    }
]

const equipments = [
    {
        name: "stick"
    },
    {
        name: "dumbell"
    },
    {
        name: "kettlebell"
    },
    {
        name: "wristWeights"
    },
    {
        name: "ankleWeights"
    },
    {
        name: "resistanceBand"
    },
    {
        name: "pilatesBall"
    }
]

const LibrarySearchFilterSection = ({ onlyFavorites, setOnlyFavorites, systemPanels, handleSelectPanel, selectedPanelsId, setSearchFilterSectionVisibility, selectedBodyParts, setSelectedBodyParts, selectedEquipments, setSelectedEquipments, t }: any) => {
    const isSystemPanelSelected = (item: any) => selectedPanelsId.some((selected: any) => selected === item.id);
    const isBodyPartSelected = (item: any) => selectedBodyParts.some((selected: any) => selected.name === item.name);
    const isEquipmentSelected = (item: any) => selectedEquipments.some((selected: any) => selected.name === item.name);

    const handleAdd = (item: any, indicator: string) => {
        if (indicator === "bodyParts") {
            if (selectedBodyParts.includes(item)) {
                setSelectedBodyParts(selectedBodyParts.filter((bodyPart: any) => bodyPart !== item));
            } else {
                setSelectedBodyParts([...selectedBodyParts, item]);
            }
        } else if (indicator === "equipments") {
            if (selectedEquipments.includes(item)) {
                setSelectedEquipments(selectedEquipments.filter((equipment: any) => equipment !== item));
            } else {
                setSelectedEquipments([...selectedEquipments, item]);
            }
        }
    }

    return (
        <>
            <Tooltip target={`.item-tooltip`} appendTo={() => document.body} mouseTrack mouseTrackLeft={10} />
            <Card className="h-screen overflow-y-auto overflow-x-hidden" style={{ borderRadius: "18px", backgroundColor: "#FFFFFF", boxShadow: "none" }}>
                <div className="flex flex-column gap-2">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <span className='text-2xl font-semibold' style={{ color: "#727A99" }}>{t("searchFilters")}</span>
                        <Button onClick={() => setSearchFilterSectionVisibility(false)} style={{ backgroundColor: "transparent", border: "none", width: '2rem', height: '1.875rem', borderRadius: '8px', paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "0.75rem", paddingRight: "0.75rem" }} className="flex justify-content-center align-items-center opacity-60">
                            <img src="/goBack.svg" />
                        </Button>
                    </div>
                    <div className="flex justify-content-between align-items-center">
                        <span className='text-md' style={{ color: "#727A99" }}>{t("onlyFavorites")}</span>
                        <InputSwitch className="only-favorites" checked={onlyFavorites} onChange={(e) => setOnlyFavorites(e.value)} />
                    </div>
                    <Divider />
                    <div className="flex flex-column gap-3">
                        <span className='text-xl' style={{ color: "#727A99" }}>{t("arrangedPanels")}</span>
                        <div className="grid h-9rem overflow-y-auto overflow-x-hidden">
                            <TooltipList items={systemPanels} col="col-6" i18nActive={false} handleClick={handleSelectPanel} isSelected={isSystemPanelSelected} t={t} />
                        </div>
                    </div>
                    <Divider />
                    <div className="flex flex-column gap-3">
                        <div className="flex justify-content-between align-items-center">
                            <span className='text-xl' style={{ color: "#727A99" }}>{t("bodyParts")}</span>
                            {/**<Button style={{ backgroundColor: "#E0E3EE", border: "0.75px solid #E0E3EE", width: '2rem', height: '1.875rem', borderRadius: '8px', paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "0.75rem", paddingRight: "0.75rem" }} className="flex justify-content-center align-items-center opacity-60">
                                <img src="/bodyPartsIcon.svg" />
                            </Button>**/}
                        </div>
                        <div className="grid">
                            <TooltipList items={bodyParts} col="col-6" i18nActive={true} handleClick={(item: any) => handleAdd(item, "bodyParts")} isSelected={isBodyPartSelected} t={t} />
                        </div>
                    </div>
                    <Divider />
                    <div className="flex flex-column gap-3">
                        <span className='text-xl' style={{ color: "#727A99" }}>{t("equipment")}</span>
                        <div className="grid">
                            <TooltipList items={equipments} col="col-6" i18nActive={true} handleClick={(item: any) => handleAdd(item, "equipments")} isSelected={isEquipmentSelected} t={t} />
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}

export default LibrarySearchFilterSection;